module.exports = function gtmEvent (url, title) {
    if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
            'event': 'VirtualPageview',
            'virtualPageURL': url,
            'virtualPageTitle' : title
        });
    } else {
        console.warn('GTM is not loaded.')
    }
}


// WEBPACK FOOTER //
// ./core/xhrController/gtmEvent.js